import { render, staticRenderFns } from "./video-popup.vue?vue&type=template&id=5d86c8dc&scoped=true"
import script from "./video-popup.vue?vue&type=script&lang=js"
export * from "./video-popup.vue?vue&type=script&lang=js"
import style0 from "./video-popup.vue?vue&type=style&index=0&id=5d86c8dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86c8dc",
  null
  
)

export default component.exports